module.exports = __webpack_public_path__ + "img/joodskindermonument_bomen_600x600px.93a7fc10.png";